declare let THREE: any;

export class TwoEndArrow extends (THREE.Object3D as { new(): any; }) {

  private static headHeight = 15;

  constructor(color) {
    super();

    const geometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(1, 0, 0)
    ]);

    const material = new THREE.LineBasicMaterial({
      color,
      depthWrite: false,
      depthTest: false
    });

    const line = new THREE.Line(geometry, material);
    line.name = 'line';
    this.add(line);

    this.add(TwoEndArrow.buildCone(color, Math.PI / 2, 'start'));
    this.add(TwoEndArrow.buildCone(color, -Math.PI / 2, 'end'));

    this.name = 'arrow';
  }

  private static buildCone(color: number, angle: number, name: string) {
    const material = new THREE.MeshBasicMaterial({
      color,
      depthWrite: false,
      depthTest: false
    });
    const geometry = new THREE.ConeBufferGeometry(4, TwoEndArrow.headHeight, 32);
    const cone = new THREE.Mesh(geometry, material);
    cone.rotation.z = angle;
    cone.name = name;
    return cone;
  }

  setLength(length: number) {
    this.getObjectByName('line').scale.x = length;
    this.getObjectByName('start').position.x = TwoEndArrow.headHeight / 2;
    this.getObjectByName('end').position.x = length - TwoEndArrow.headHeight / 2;
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/TwoEndArrow.ts